import { minutesToPercent } from "../../../../../components/RRule/timeline-range.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/count/CountOccurrenceTrack.tsx
function CountOccurrenceTrack({ segments }) {
	return /* @__PURE__ */ jsx("div", {
		className: "relative h-[1lh] w-full",
		children: segments.map((segment) => /* @__PURE__ */ jsx("div", {
			className: "border-main absolute top-1/2 -translate-y-1/2 border-t border-dashed",
			style: {
				left: `${minutesToPercent(segment.start)}%`,
				width: `${minutesToPercent(segment.end - segment.start)}%`
			}
		}, `${segment.start}-${segment.end}`))
	});
}
//#endregion
export { CountOccurrenceTrack };

//# sourceMappingURL=CountOccurrenceTrack.js.map